import {useWeb3React} from "@web3-react/core";
import React, {useEffect, useState} from "react";
import {Contract, ethers} from "ethers";
import mintAbi from "../zug.json"
import {Button, Col, Container, InputGroup, Row} from "react-bootstrap";
import InputGroupText from "react-bootstrap/InputGroupText";
import {JsonRpcProvider, Web3Provider} from "@ethersproject/providers";

function Mint () {
    const { isActive, chainId, accounts, provider, connector } = useWeb3React()
    const [connected, setConnected] = useState(false)
    const [contractAddress, setContractAddress] = useState('0x62113121f11AB2CB8cB3A5c8330793b14B541a1F')
    const [minted, setMinted] = useState(0)
    const [amount, setAmount] = useState(1)
    const [live, setLive] = useState(true)
    const [supply, setSupply] = useState(2222)
    const [mintSucceeded, setMintSucceeded] = useState(false)
    const [collectionName, setCollectionName] = useState('')
    const [collectionDescription, setCollectionDescription] = useState('Punk Apes NFT')
    const [collectionExample, setCollectionExample] = useState('1')
    const [collectionImage, setCollectionImage] = useState('Images/1.jpeg')

    const getChainId = () => {
        return 109;
    }

    const getContractAddress = () => {
        let path = window.location.search
        let parts = path.split('?');
        return parts[1]
    }

    const getContract = () => {
        let CA = '0x62113121f11AB2CB8cB3A5c8330793b14B541a1F'
        if(provider?.getSigner()) {
            return new Contract(CA, mintAbi, provider?.getSigner())
        } else {
            let defaultProvider = new JsonRpcProvider('https://www.shibrpc.com', getChainId());
            return new Contract(CA, mintAbi, defaultProvider)
        }
    }

    const readState = async () => {
        let contract = getContract()
        setMinted(await contract.totalSupply());
        setCollectionName(await contract.name());

        //const example = Math.round((Math.random() * 1000000)) % 3333;
        setCollectionExample('1')

        if(!collectionDescription) {
            setCollectionDescription('')
            setCollectionImage('')
        }
        setLive(!(await contract.paused()))
    }

    const mint = async () => {
        setMintSucceeded(false)
        try {
            let contract = getContract()
            let costs = ethers.utils.parseEther('5');
            let tx = await contract.mint(amount, {value: (costs.mul(amount)).toString()})
            await tx.wait()

            setMintSucceeded(true)
            readState().then(() => {

            })
        } catch (e) {

        }
    }

    const toggleConnect = async () => {
        console.log(connector);
        await connector.activate(getChainId())
    }

    useEffect( () => {
        if(!contractAddress) {
            setContractAddress(getContractAddress)
        }
        if(isActive && provider) {
            if(!connected) {
                readState().then(() => {

                })
                setConnected(true)
            }
        }
        if(!collectionName) {
            readState().then(() => {

            })
        }
    })

    const amountSubstract = async () => {
        setAmount(Math.max(amount - 1, 1));
    }

    const amountAdd = async () => {
        setAmount(Math.min(amount + 1, 20));
    }

    return <Container>
        <Row>
            <Col className={'content-center'}>
                <img className={'img-fluid logo'} src={'Images/logo.png'} />
            </Col>
        </Row>
        <Row>
            <Col className={'col-12 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12'}>
                <img className={'nft img-fluid'} src={collectionImage} />
            </Col>
            <Col className={'col-12 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12'}>
                { connected && collectionName ?
                    <>
                        <h1>Mint PunkApes NFT!</h1>
                        <p></p>
                    </> : <></>
                }
                { connected && live ?
                    <>
                        <p>
                            Connected with <strong>{accounts ? accounts[0].substring(0, 8) + '...' : ''}</strong>
                        </p>

                        <h2>
                            Progress : <strong>{minted.toString()} / {supply.toString()}</strong>
                        </h2>

                        <InputGroup>
                            <Button onClick={amountSubstract}>-</Button>
                            <InputGroupText>{amount}</InputGroupText>
                            <Button onClick={amountAdd}>+</Button>
                            <Button variant={"danger"} onClick={mint}>Mint [5 BONE each]</Button>
                        </InputGroup>
                        { mintSucceeded ? <p>Your PunkApes were minted! Thank you!</p> : <></> }

                        <p>
                            Contract : <a target={'_blank'} href={ contractAddress ? ('https://www.shibariumscan.io/address/' + contractAddress + '?tab=read_contract') : ''}>Shibariumscan</a>
                        </p>

                    </> : <div className={'text-center'}>
                        <Button onClick={toggleConnect}>Connect Metamask</Button>
                    </div>
                }
            </Col>
            <Col className={'col-xl-4 col-lg-4 d-none d-xl-block d-lg-block'}>
                <img className={'nft img-fluid'} src={'Images/2.jpeg'} />
            </Col>
        </Row>
    </Container>
}

export default Mint;
